// INTERFACE

export enum TxnLoadMode {
  REFRESH = 0,
  REVERSE = 1
}

export default class ParsedTransaction {
  public transactionId: string
  public groupId: string
  public block: number
  public time: number
  public protocol: string
  public app: number
  public action: string
  public params: string[]
  public assetsIn: { [key: number] : number }
  public assetsOut: { [key: number] : number }

  constructor(
    transaction: {},
    protocol: string,
    app: number,
    action: string,
    params: string[],
    assetsIn: { [key: number] : number },
    assetsOut: { [key: number] : number },
  ) {
    this.transactionId = transaction['id']
    this.groupId = transaction['group']
    this.block = transaction['confirmed-round']
    this.time = transaction['round-time']
    this.protocol = protocol
    this.app = app
    this.action = action
    this.params = params
    
    // flatten assets
     for (var [assetId, amount] of Object.entries(assetsIn)) {
      if (assetId in assetsOut && amount > assetsOut[assetId]) {
        assetsIn[assetId] -= assetsOut[assetId]
        delete assetsOut[assetId]
      }
    }
    
    this.assetsIn = assetsIn
    this.assetsOut = assetsOut
  }
}
